import React from 'react';

import { ReactComponent as SuccessGreen } from 'assets/icons/apptrackSubmit.svg';
import { Modal } from 'components';
import { Button } from 'antd';

const SuccessModal = props => {
  let {
    isVisible,
    setVisible,
    message = 
        <div>
            <div className="content-title-2">
                Επιτυχής Υποβολή
            </div>
            Η Αίτηση Επενδυτικού Σχεδίου έχει υποβληθεί επιτυχώς στο ΤΑΑ.
        </div>,
  } = props;

  let Icon = SuccessGreen;

  
  return (
    <Modal
      isVisible={isVisible}
      closable={true}
      onCancel={() => setVisible(false)}
      width={450}
      footer={
        [
          <Button
            className='closeSuccessModal'
            style={{width: '100%'}}
            onClick={() => setVisible(false)}
          >Κλείσιμο</Button>,
        ]
      }
      className={'invalid-modal custom-modal warning-modal'}
    >
      <div className="custom-modal__header"><Icon/></div>
      <div className="custom-modal__body">{message}</div>
    </Modal>
  );
};

export default SuccessModal;
